export default __webpack_public_path__ + "static/media/cloudUpload.99cc9937.svg";